var _rect, _rect2, _path, _path2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextwizLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 20,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 143.314,
    y: 39.7715,
    width: 18,
    height: 112.5,
    rx: 9,
    fill: "#6122AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4571 75.7715C58.4571 70.8009 62.4865 66.7715 67.4571 66.7715V66.7715C72.4277 66.7715 76.4571 70.8009 76.4571 75.7715V115.629C76.4571 120.599 72.4277 124.629 67.4571 124.629V124.629C62.4865 124.629 58.4571 120.599 58.4571 115.629V75.7715Z",
    fill: "#6122AA",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1714 80.2725C30.1714 75.3019 34.2009 71.2725 39.1714 71.2725V71.2725C44.142 71.2725 48.1714 75.3019 48.1714 80.2725V110.487C48.1714 115.457 44.142 119.487 39.1714 119.487V119.487C34.2009 119.487 30.1714 115.457 30.1714 110.487V80.2725Z",
    fill: "#6122AA",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115.029,
    y: 47.4854,
    width: 18,
    height: 96.4286,
    rx: 9,
    fill: "#6122AA",
    fillOpacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7428,
    y: 60.3428,
    width: 18,
    height: 70.7143,
    rx: 9,
    fill: "#6122AA",
    fillOpacity: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextwizLogo);
export default __webpack_public_path__ + "static/media/textwiz_logo.39188530bd8dd52afa565ad42932d1ac.svg";
export { ForwardRef as ReactComponent };